import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { compose } from 'redux';

import * as Shapes from '../../shapes';
import dataComponent from '../../hoc/dataComponent';
import AboutGroup from './AboutGroup';
import BlurFilterSvg from '../livestream-event/BlurFilterSvg';

import { messages } from '../messages/Profile';

import { loadProfileAbout } from '../../actions/profile';
import { selectArtistIdFromSlug, selectProfile } from '../../selectors/profile';

import styles from './ProfileAbout.css';
import Expandable from '../common/Expandable';
import * as clientActions from '../../actions/client';
import { getBaseHelmet } from '../../utils/profile';
import { META_TITLE_PREFIX } from '../../constants';

class ProfileAbout extends PureComponent {
  static propTypes = {
    profile: Shapes.Profile.isRequired,

    intl: intlShape,
  };

  static onDataFetch(store, params, location, intl) {
    const profile = selectProfile(store.getState(), params.slug);
    const { name } = profile;
    const title = name;
    const description = intl.formatMessage(messages.profileAboutMetaDescription, { name });
    store.dispatch(
      clientActions.setHelmet({
        ...getBaseHelmet(profile, location, intl),
        title: META_TITLE_PREFIX + title,
        description,
        canonicalRoute: `/profiles/${params.slug}/about`,
        keywords: intl.formatMessage(messages.profileAboutMetaKeywords, { name }),
        ogTitle: title,
        ogDescription: description,
      })
    );
  }

  render() {
    const { profile, intl } = this.props;

    const { slug } = profile;
    const { formatMessage } = intl;

    return (
      <div>
        {profile.biography && (
          <Expandable key={profile.id}>
            <p className={styles.artistBio}>{profile.biography}</p>
          </Expandable>
        )}
        {profile.latestReleases && (
          <AboutGroup
            id="latest-releases"
            title={formatMessage(messages.profileAboutLatestReleases)}
            items={profile.latestReleases}
            slug={slug}
          />
        )}
        {profile.featuredOn && (
          <AboutGroup
            id="featured-on"
            title={formatMessage(messages.profileAboutFeaturedOn)}
            items={profile.featuredOn}
            slug={slug}
          />
        )}
        {profile.recommendedAlbums && (
          <AboutGroup
            id="recommended-albums"
            title={formatMessage(messages.profileAboutRecommendedAlbums)}
            items={profile.recommendedAlbums}
            slug={slug}
          />
        )}
        {profile.concerts && (
          <React.Fragment>
            <AboutGroup
              id="concerts"
              title={formatMessage(messages.profileAboutConcerts)}
              items={profile.concerts}
              slug={slug}
              isConcertGroup
            />
            <BlurFilterSvg />
          </React.Fragment>
        )}
        {profile.similarArtists && profile.similarArtists.length > 0 && (
          <AboutGroup
            id="recommended-artists"
            title={formatMessage(messages.profileAboutRecommendedArtists)}
            items={profile.similarArtists}
            slug={slug}
            isArtistGroup
          />
        )}
      </div>
    );
  }
}

function fetchData(store, { slug }) {
  const state = store.getState();
  const id = selectArtistIdFromSlug(state, slug);
  return store.dispatch(loadProfileAbout(id));
}

function mapStateToProps(state, ownProps) {
  const { slug } = ownProps.params;

  const profile = selectProfile(state, slug);

  return {
    profile,
  };
}

export default compose(
  dataComponent(fetchData),
  connect(mapStateToProps, {}),
  injectIntl
)(ProfileAbout);
